/* eslint-disable no-const-assign */
import { Add, Remove } from '@mui/icons-material';
import { Box, Grid, IconButton, TextField, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import React from 'react';

export default function PieCounter(props) {
	const { text, value, name } = props;
	const { setFieldValue } = useFormikContext();
	return (
		<Box>
			<Typography variant='body'>{text} </Typography>
			<Grid
				container
				sx={{
					flexGrow: 1,
					display: 'flex',
					flexWrap: 'nowrap',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Grid item>
					<IconButton
						color='inherit'
						onClick={() => {
							if (value === 0) {
								setFieldValue(name, 0);
							} else {
								setFieldValue(name, value - 1);
							}
						}}
					>
						<Remove />
					</IconButton>
				</Grid>
				<Grid item>
					<TextField {...props} />
					{/* <TextField
						name='counterRebElote'
						margin='dense'
						type='number'
						value={counter}
						onChange={(e) => {
							setCounter(e.target.value);
						}}
					/> */}
				</Grid>
				<Grid item>
					<IconButton
						color='inherit'
						onClick={() => {
							setFieldValue(name, value + 1);
						}}
					>
						<Add />
					</IconButton>
				</Grid>
			</Grid>
		</Box>
	);
}
